import { message } from "antd";
import {permissionCheck} from "../../../../utils";


export default function auditStory({component,record,editParams,params}){
    return {
        name: "审核稿件", condition:null,conditionFun:()=>record.storyId != undefined && record.status === "已回稿"&&!permissionCheck("business:appointment:get"),onOk: () => {
            window.request({
                url: "/cm-sites-pms/story/getRecordByContributeAndDeptId",
                body: {storyId:record.storyId},
                callBack: (res) => {
                    if (res&&res.id) {
                        window.openEditById({
                            params: {
                                ...editParams,
                            },
                            ...params,
                            id:res.id
                        });
                    }else{
                        message.warning("未查询到投稿记录！")
                    }
                },
                errorCallBack: (e) => {
                },
            })
        }
    };
};